// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkboxes[data-v-2411b05f]{display:grid;grid-auto-flow:column;grid-column-gap:.3rem;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;color:#44004e;width:-webkit-max-content;width:-moz-max-content;width:max-content}[data-v-2411b05f] .form-row .form-row-inner-container{grid-template-columns:3rem calc(100% - 3rem)}.save-button[data-v-2411b05f]{text-align:center;width:1.2rem}[data-v-2411b05f] .multisig_ban_container{padding-left:.7rem}", ""]);
// Exports
module.exports = exports;
